import { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  FormHelperText,
} from "@mui/material";
import { useCreateMigrationParameter } from "../../hooks/useCreateMigrationParameter";

interface ParameterFormMigracionProps {
  onSuccess?: () => void;
}

export const ParameterFormMigracion = ({
  onSuccess,
}: ParameterFormMigracionProps) => {
  const [usefulLifeValue, setUsefulLifeValue] = useState("");
  const [usefulLifeUnit, setUsefulLifeUnit] = useState("");
  const [errors, setErrors] = useState({
    usefulLifeValue: "",
    usefulLifeUnit: "",
  });

  const { saveParameter, loading } = useCreateMigrationParameter();

  const validate = () => {
  const newErrors = {
    usefulLifeValue: "",
    usefulLifeUnit: "",
  };

  if (!usefulLifeValue) {
    newErrors.usefulLifeValue = "La vida útil es obligatoria";
  } else if (!/^\d+$/.test(usefulLifeValue)) {
    newErrors.usefulLifeValue = "La vida útil debe ser un número entero";
  } else if (Number(usefulLifeValue) <= 0) {
    newErrors.usefulLifeValue = "La vida útil debe ser mayor a 0";
  } else if (usefulLifeUnit === "YEARS" && Number(usefulLifeValue) > 10) {
    newErrors.usefulLifeValue = "La vida útil en años no puede superar 10 años";
  } else if (usefulLifeUnit === "MONTHS" && Number(usefulLifeValue) > 120) {
    newErrors.usefulLifeValue = "La vida útil en meses no puede superar 120 meses";
  }

  if (!usefulLifeUnit) {
    newErrors.usefulLifeUnit = "La unidad es obligatoria";
  }

  setErrors(newErrors);
  return !newErrors.usefulLifeValue && !newErrors.usefulLifeUnit;
};

  const handleSubmit = () => {
    if (!validate()) return;

    saveParameter(
      {
        usefulLifeValue: Number(usefulLifeValue),
        usefulLifeUnit,
      },
      {
        onSuccess: () => {
          setUsefulLifeValue("");
          setUsefulLifeUnit("");
          setErrors({
            usefulLifeValue: "",
            usefulLifeUnit: "",
          });
          onSuccess?.();
        },
      }
    );
  };

  return (
    <Box>
      <Typography variant="h6" fontWeight={700} mb={3}>
        Parametrización de Migración
      </Typography>

      <Stack spacing={3}>
          <TextField
          label={usefulLifeUnit === "MONTHS" ? "Vida útil en meses" : "Vida útil en años"}
          type="text"
          value={usefulLifeValue}
          onChange={(e) => {
            const value = e.target.value;

            if (/^\d*$/.test(value)) {
              setUsefulLifeValue(value);
            }
          }}
          error={!!errors.usefulLifeValue}
          helperText={
            errors.usefulLifeValue ||
            (usefulLifeUnit === "MONTHS"
              ? "Ingrese un valor entre 1 y 120 meses"
              : usefulLifeUnit === "YEARS"
                ? "Ingrese un valor entre 1 y 10 años"
                : "Seleccione la unidad para validar el rango")
          }
          fullWidth
          required
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            maxLength: 3,
          }}
        />

        <FormControl fullWidth required error={!!errors.usefulLifeUnit}>
          <InputLabel>Unidad</InputLabel>
          <Select
            value={usefulLifeUnit}
            label="Unidad"
            onChange={(e) => setUsefulLifeUnit(e.target.value)}
          >
            <MenuItem value="YEARS">Años</MenuItem>
            <MenuItem value="MONTHS">Meses</MenuItem>
          </Select>
          <FormHelperText>{errors.usefulLifeUnit}</FormHelperText>
        </FormControl>

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Guardando..." : "Guardar"}
        </Button>
      </Stack>
    </Box>
  );
};